import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './Blog.css';

const BlogDetail = () => {
  const { blogId } = useParams();
  const [blog, setBlog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchBlog = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get(`https://apiqms.shigjeta.com/api/blogs/${blogId}`);
        setBlog(response.data);
      } catch (err) {
        console.error("Error fetching blog details:", err);
        setError("Failed to load blog details.");
      } finally {
        setIsLoading(false);
      }
    };

    if (blogId) {
      fetchBlog();
    }

  }, [blogId]);

  if (isLoading) return <p>Loading blog...</p>;
  if (error) return <p className="error-message">{error}</p>;
  if (!blog) return <p>Blog not found.</p>;

  // Ensure tags is an array
  const tagsArray = blog.tags
    ? (Array.isArray(blog.tags) ? blog.tags : blog.tags.split(',').map(t => t.trim()))
    : [];

  const additionalImagesArray = blog.additionalImages
    ? (Array.isArray(blog.additionalImages)
        ? blog.additionalImages
        : String(blog.additionalImages).split(',').map(img => img.trim()).filter(img => img !== '')
      )
    : [];

  return (
    <div className="blog-detail">
      {/* --- MODIFIED ORDER HERE --- */}
      <h1 className="blog-title">{blog.title}</h1>
      <p className="blog-category">CATEGORY: {blog.category}</p>
      
      {/* Main Content Area using the new two-column structure */}
      <div className="blog-main-content">
        
        {/* Left Column for Image and Tags */}
        <div className="blog-left-column">
          {blog.mainImage && (
            <img src={`https://apiqms.shigjeta.com${blog.mainImage}`} alt={blog.title} className="blog-main-image" />
          )}
          {tagsArray.length > 0 && (
            <div className="blog-tags">
              <h3 className="tags-title">Tags:</h3>
              <ul className="tags-list">
                {tagsArray.map((tag, index) => (
                  <li key={index} className="tag-item">{tag}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Right Column for Description */}
        <div className="blog-right-column">
          <div className='blog-description' dangerouslySetInnerHTML={{ __html: blog.description }} />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImagesArray.length > 0 && (
        <div className="additional-images">
          <h3 className="images-title">Additional Images:</h3>
          <div className="images-grid">
            {additionalImagesArray.map((img, index) => (
              <img key={index} src={`https://apiqms.shigjeta.com${img}`} alt={`Additional image ${index + 1}`} className="additional-image" />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogDetail;